import { Page, Cashback, ItemCashback } from "@/models"
import { AxiosRequestConfig } from "axios"
import { Inject } from "inversify-props"
import { CashbackServiceAdapter } from "./adapter/CashbackServiceAdapter"

export class FindCashbackUseCase {
	@Inject('CashbackServiceAdapter')
	private cashBackServiceAdapter!: CashbackServiceAdapter

	findCashBackPorCliente = async (params?: any, config?: AxiosRequestConfig): Promise<Page<Cashback>> =>
		await this.cashBackServiceAdapter.findCashBackPorCliente(params, config)

	findItensCashback = async (params?: any, config?: AxiosRequestConfig): Promise<Page<ItemCashback>> =>
		await this.cashBackServiceAdapter.findItensCashback(params, config) 
}